import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Footer from "./Footer"
import Navbar from "./Navigation/Navbar/Navbar";
import SideNav from "./Navigation/Navbar/SideNav/SideNav";

const Wrapper = styled.div`
  max-width: ${props => (props.hasHero ? '70vw' : 'none')};
  margin: 0 auto;
`

export default function Layout({ children }) {
  return (
    <>
      <SideNav />
      <Navbar />
      <Wrapper>
        <main>{children}</main>
      </Wrapper>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {
  hasHero: false
};

